import { render, staticRenderFns } from "./submit-bar.vue?vue&type=template&id=425f854a&scoped=true&"
import script from "./submit-bar.js?vue&type=script&lang=js&"
export * from "./submit-bar.js?vue&type=script&lang=js&"
import style0 from "./submit-bar.vue?vue&type=style&index=0&id=425f854a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f854a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('425f854a')) {
      api.createRecord('425f854a', component.options)
    } else {
      api.reload('425f854a', component.options)
    }
    module.hot.accept("./submit-bar.vue?vue&type=template&id=425f854a&scoped=true&", function () {
      api.rerender('425f854a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cart/components/submit-bar/submit-bar.vue"
export default component.exports